/* eslint-disable import/no-mutable-exports */
const env = 'production'
let awsConfig = {}
let commonConfig = {}

switch (env) {
  case 'production':
    awsConfig = {
      clientId: 'roul2k6desrinr8onr1c45l9p',
      cognitoDomain: 'https://going-cloud-billing-portal.auth.ap-northeast-1.amazoncognito.com',
      apiEndpoint: 'https://api.billing.going.cloud',
    }
    commonConfig = {
      domain: 'https://billing.going.cloud',
    }
    break
  case 'stage':
    awsConfig = {
      clientId: 'roul2k6desrinr8onr1c45l9p',
      cognitoDomain: 'https://going-cloud-billing-portal.auth.ap-northeast-1.amazoncognito.com',
      apiEndpoint: 'https://staging-api.billing.going.cloud',
    }
    commonConfig = {
      domain: 'https://staging-billing.going.cloud',
    }
    break
  default:
    awsConfig = {
      clientId: 'roul2k6desrinr8onr1c45l9p',
      cognitoDomain: 'https://going-cloud-billing-portal.auth.ap-northeast-1.amazoncognito.com',
      apiEndpoint: 'https://staging-api.billing.going.cloud',
    }
    commonConfig = {
      domain: 'http://localhost:3000',
    }
    break
}

export { awsConfig, commonConfig }
